export const downloadDocument = (url, fileName) => {
  const downloadLink = document.createElement("a");

  downloadLink.target = "_blank";
  downloadLink.href = url;
  downloadLink.download = fileName;
  downloadLink.click();
};
